import React, { useState, useEffect } from "react"

const Paginator = ({ 
      pageOptions, 
      setPageOptions, 
      compoundList,
      explore
    }) => {
    const [formData, setFormData] = useState({
        totalPages: 0,
        startPage: 1,
        currentPage: 0,
    })
    const [paramsData, setParamsData] = useState([])

    useEffect(() => {
        let numOfPages = Math.ceil(compoundList?.length / 6)
        const pages = Array.from({ length: numOfPages > 10 ? 10 : numOfPages }, (_, index) => index + 1);
        setFormData({...formData, totalPages: numOfPages, endPage: numOfPages > 10 ? 10 : numOfPages, pages: pages, currentPage: 1})
    }, [compoundList])

    useEffect(() => {
        if(formData.currentPage == 1){
            setPageOptions({...pageOptions, data: compoundList?.slice(0,6)})
        } else if(formData.currentPage > 1 && formData.currentPage < formData.totalPages){
            setPageOptions({...pageOptions, data: compoundList?.slice((formData.currentPage -1) * 6 ,formData.currentPage * 6)})
        } else if(formData.currentPage = formData.totalPages){
            setPageOptions({...pageOptions, data: compoundList?.slice((formData.currentPage -1) * 6 )})
        }

        if(formData.currentPage <= 6 ){
            let numOfPages = Math.ceil(compoundList?.length / 6)
            const pages = Array.from({ length: numOfPages > 10 ? 10 : numOfPages }, (_, index) => index + 1)
            setParamsData(pages)
        } else if(formData.currentPage > 6 && formData.totalPages > 10 ){
            if(formData.currentPage+5 > formData.totalPages) return
            const pages = Array.from({ length: 10 }, (value, index) => (formData.currentPage-5) + index);
            setParamsData(pages)
        }
    }, [formData])

    return (
       <>
        {explore && <ul className="pagination ">
            <li style={{ marginRi5ht: "5px" }} className='page-item  rounded'>
                <a className='page-link border-0   rounded text-dark '
                    style={{ fontSize: "24px", opacity: formData?.currentPage === 1 ? .3 : 1 }}
                    onClick={() => {
                        if (formData?.currentPage === 1) {
                            return
                        } else {
                            setFormData({...formData, currentPage: formData?.currentPage - 1})
                            return
                        }
                    }}
                    >&lt;</a>
            </li>
            {formData.totalPages > 10 && formData.currentPage >= 7  &&
                <>
                <li className={formData.currentPage === formData.totalPages  ?
                        ' page-link border-0 rounded  text-light  ' :
                        'page-link border-0  rounded text-dark  '}
                >
                    
                    <a className={formData.currentPage === formData.startPage ?
                        ' page-link border-0 rounded  text-light  ' :
                        'page-link border-0  rounded text-dark  '}
                        style={{ userSelect: "none", background: formData ?.currentPage === formData.startPage ? "#25375c" : "#ffffff", fontSize: "12px", }}
                        onClick={() => {
                            if (formData.startPage == formData ?.currentPage) {
                                return
                            } else {
                                setFormData({...formData, currentPage: 1})
                            }
                        }}>1</a>
                </li>
                {<li className='border-0 rounded text-dark' style={{background: '#fff', paddingTop: '.75rem'}}>
                    ...
                </li>}
                </>}
            {paramsData.map((page, index) =>{
                if(index < 10){
                    if(formData.currentPage >= 7 && index == 0) return
                    return <li key={index}
                    className={formData ?.currentPage === page ?
                        ' page-link border-0 rounded  text-light  ' :
                        'page-link border-0  rounded text-dark  '}
                >
                    <a className={formData ?.currentPage === page ?
                        ' page-link border-0 rounded  text-light  ' :
                        'page-link border-0  rounded text-dark  '}
                        style={{ userSelect: "none", background: formData ?.currentPage === page ? "#25375c" : "#ffffff", fontSize: "14px", }}
                        onClick={() => {
                            if (page == formData?.currentPage) {
                                return
                            } else {
                                setFormData({...formData, currentPage: page})
                            }
                        }}>{page}</a>
                </li>
                }
            })}
            {formData.totalPages > 10 &&
                <>
                {formData?.currentPage+5 < formData?.totalPages && <li className='border-0 rounded text-dark' style={{background: '#fff', paddingTop: '.75rem'}}>
                    ...
                </li>}
                <li className={formData ?.currentPage === formData.totalPages ?
                        ' page-link border-0 rounded  text-light  ' :
                        'page-link border-0  rounded text-dark  '}
                >
                    
                    <a className={formData?.currentPage === formData.totalPages ?
                        ' page-link border-0 rounded  text-light  ' :
                        'page-link border-0  rounded text-dark  '}
                        style={{ userSelect: "none", background: formData ?.currentPage === formData.totalPages ? "#25375c" : "#ffffff", fontSize: "14px", }}
                        onClick={() => {
                            if (formData.totalPages == formData ?.currentPage) {
                                return
                            } else {
                                setFormData({...formData,currentPage : formData.totalPages})
                            }
                        }}>{formData.totalPages}</a>
                </li>
                </>}
            <li style={{ marginLeft: "5px" }} className='page-item  rounded'  >
                <a className='page-link border-0   rounded text-dark '
                    style={{ fontSize: "24px", opacity: formData ?.currentPage === formData ?.totalPages ? .3 : 1 }}
                    onClick={() => {
                        if (formData ?.currentPage === formData ?.totalPages) {
                            return
                        } else {
                            setFormData({...formData,currentPage : formData.currentPage +1})
                        }
                    }}
                    >&gt;</a>
            </li>
        </ul>}
       </>
    );
}



Paginator.defaultProps = {
    initialPage: 1,
    pageSize: 9,
    items: []
};
export default Paginator;

 